import {PromotionList} from "../../domain/dtos/promotion-list";
import {PromotionMapper} from "./promotion.mapper";

export class PromotionListMapper {
    static deserialize(param: any): PromotionList {
        return {
            promo: param.results.map(PromotionMapper.deserialize),
            totalPages: parseInt(param.totalPages),
            totalRecords: param.totalResults
        } as PromotionList
    }
}
